<script setup lang="ts">
import { computed, onMounted, ref } from 'vue'
import accessDenied from './assets/undraw_access_denied_re_awnf.svg'

export interface AccessDeniedProps {
  /** If the user has any access-right in the array the component will render the default slot. */
  canAccess?: (() => boolean)[]
  /** Gives the user a page with a reason why they don't have access to the resource.
   * @default true
   */
  showAccessDenied?: boolean
}

const props = withDefaults(defineProps<AccessDeniedProps>(), {
  showAccessDenied: true,
  canAccess: () => []
})

const isMounted = ref(false)

onMounted(() => {
  setTimeout(() => {
    isMounted.value = true
  })
})

const canAccess = computed(() => {
  if (Array.isArray(props.canAccess) && props.canAccess.length === 0) {
    return true
  }

  for (let i = 0; i < props.canAccess.length; i++) {
    const accessRight = props.canAccess[i]
    const canAccess = accessRight()
    if (canAccess) {
      return true
    }
  }
  return false
})
</script>
<template>
  <template v-if="canAccess">
    <slot />
  </template>
  <slot v-else name="access-denied">
    <div class="p-8 text-center text-2xl">Access denied</div>
    <slot name="access-denied-image" v-bind="{ image: accessDenied }">
      <img class="mx-auto w-60 sm:w-80" :src="accessDenied" />
    </slot>
    <div class="pt-8 text-center">You don't have access to this resource.</div>
    <div class="text-soft text-center text-sm">
      <slot name="access-denied-text" v-bind="{
        text: 'Please contact your system-administrator for further assistance'
      }">
        Please contact your system-administrator for further assistance
      </slot>
    </div>
  </slot>
</template>
